import { render, staticRenderFns } from "./InvalidCalculation.vue?vue&type=template&id=485ee455"
import script from "./InvalidCalculation.vue?vue&type=script&lang=js"
export * from "./InvalidCalculation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports